
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/mobile/index.md?type=demo')
};